import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ClassificationEmployeur } from '../../core/model/classification-employeur';
import { ClassificationEmployeurService } from '../../core/service/classification-employeur.service';

@Component({
  selector: 'app-add-classification-employeur',
  templateUrl: './add-classification-employeur.component.html',
  styleUrls: ['./add-classification-employeur.component.scss']
})
export class AddClassificationEmployeurComponent implements OnInit {
  
  classificationEmployeur: ClassificationEmployeur = new ClassificationEmployeur();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _classificationEmployeurService: ClassificationEmployeurService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
  }


  save(): void {
    this.spinner.show();

    this.pressButton = true;

    this._classificationEmployeurService
      .post(this.classificationEmployeur)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

}
